import IFinancingV3CustomerExtraData from "@/module/main/dto/financing-v3/IFinancingV3CustomerExtraData";
import PlatformUsedType from "@/module/main/dto/financing-v3/PlatformUsedTypeEnum";

export default class FinancingV3CustomerExtraData implements IFinancingV3CustomerExtraData
{
    public platformUsed?: PlatformUsedType;

    constructor(props: IFinancingV3CustomerExtraData)
    {
        this.platformUsed = props.platformUsed;
    }
}

